import React from "react";
import { FaTimesCircle } from "react-icons/fa";
import PopUp from "../../components/PopUp";
import { RectBtn } from "../../components/General";
import { deleteRoom as deleteRoomApi } from "../../apis/Room.Api";
import { useDispatch, useSelector } from "react-redux";
import { deleteRoom } from "../../features/slices/roomSlice";
import { selectDevice, selectSensor, selectUserData } from "../../features/store";
import { deleteSensor } from "../../features/slices/sensorSlice";
import { deleteDevice } from "../../features/slices/deviceSlice";
import { useSnackbar } from "notistack";
const DeleteConfig = ({ selectedConfig, setSelectedConfig, openDelete, setOpenDelete }) => {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const userData = useSelector(selectUserData);
    const sensors = useSelector(selectSensor);
    const devices = useSelector(selectDevice);
    async function confirmDeleteConfig() {
        let r = await deleteRoomApi({ room_id: selectedConfig.id });
        if (r.data.indicator) {
            enqueueSnackbar(`Successfully deleted room.`, { variant: "success" });
            dispatch(deleteRoom({ roomId: selectedConfig.id }));
        } else {
            enqueueSnackbar(r.data.message, { variant: "error" });
            return;
        }
        for (let sid of Object.keys(sensors)) {
            if (sensors[sid].roomId === selectedConfig.id) {
                dispatch(deleteSensor({ sensorId: sid }));
            }
        }
        for (let did of Object.keys(devices)) {
            if (devices[did].roomId === selectedConfig.id) {
                dispatch(deleteDevice({ deviceId: did }));
            }
        }
        setOpenDelete(false);
        setSelectedConfig({});
    }
    return (
        <PopUp width={40} height={50} switchOn={openDelete}>
            <div className="pop-up-content-wrapper">
                <div className="pop-up-row">
                    <h4>Confirmation</h4>
                    <FaTimesCircle
                        className="pop-up-close-btn"
                        onClick={() => {
                            setOpenDelete(false);
                        }}
                    />
                </div>
                <div className="pop-up-division-line"></div>
                <div className="pop-up-body">
                    <div className="confirmation-wrapper">
                        <h4> Delete Room? </h4>
                        <p className="description">
                            By confirming, the room
                            <strong>{" " + selectedConfig.room + " "}</strong>
                            and <strong> ALL </strong> its sensors & devices will be deleted. This action cannot be
                            restored.
                        </p>
                        <div className="btn-wrapper">
                            <RectBtn onClick={confirmDeleteConfig} warning={true}>
                                <p>Delete</p>
                            </RectBtn>
                        </div>
                    </div>
                </div>
            </div>
        </PopUp>
    );
};

export default DeleteConfig;
